<template>
    <div class='body-main'>
        <div class='cart-header'>
            <div class='cart-header-warp clearfix'>
                <div class='cart-title left clearfix'>
                    <h1 class='left'>我的购物车</h1>

                    <div class='left js-number-box-cart' v-if="userNeme != ''">
                        共<span class='js-coures-num'>{{cartCount}}</span>门，已选择<span
                            class='js-choice-num'>{{optFor}}</span>门
                    </div>

                </div>
                <div class='right'>

                    <div class='clearfix'>
                        <span class='left'><a class='js-myorderbtn  myorder-history' href='/Ordercenter'>我的订单中心</a></span>
                        <span class='left num js-order-num' style='display: none;'>0</span>
                    </div>

                </div>
            </div>
        </div>

        <div class='cart-body' id='cartBody'>
            <div v-if="userNeme != '' && cartCount != 0">
                <div class='cart-body-title clearfix'>
                    <div class='item-1 l'>
                        <el-checkbox v-model="checked" @change="isAllchecked" border>全选</el-checkbox>

                    </div>

                    <div class='item-2 l'>
                        <span class='c-4d555d'>课程</span>
                    </div>

                    <div class='item-3 l'>
                        <span class='c-4d555d'>金额</span>
                    </div>

                    <div class='item-4 l'>
                        <span class='c-4d555d'>操作</span>
                    </div>
                </div>

                <div id='js-cart-body-table' class='cart-body-table'>
                    <div class='item clearfix' v-for="item in cartdata">
                        <div class='item-1'>
                            <el-checkbox v-model="item.chek" @change="ischecked(item.chek,item)"></el-checkbox>
                        </div>
                        <div class='item-2 clearfix'>
                            <router-link :to="'/class/' + item.jobsdataId" target="_blank" class="img-box l">
                                <img :src='item.jobsdataId.imggwc' width='160' height='90'/>
                            </router-link>
                            <dl class='l has-package'>
                                <a href="javascript:void(0);">
                                    {{item.gzleibie}}-{{item.gzxiangmu}}-{{item.gzleixing}}
                                </a>
                                <!-- table -->
                                <el-table
                                        :data="setapplydata(item)"
                                        tooltip-effect="dark"
                                        style="width: 100%"
                                >
                                    <el-table-column
                                            label="序号"
                                            type="index"
                                            width="50">
                                    </el-table-column>

                                    <el-table-column
                                            prop="cardId"
                                            label="身份证号码"
                                            width="250">
                                    </el-table-column>

                                    <el-table-column
                                            label="操作"
                                            header-align="center">
                                        <template slot-scope="scope">
                                            <el-button
                                                    size="mini"
                                                    @click="handleEdit(scope.$index, scope.row)">编辑
                                            </el-button>
                                            <el-button
                                                    size="mini"
                                                    type="danger"
                                                    @click="handleDelete(scope.$index, scope.row)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                            label="价格"
                                            width="100"
                                    >
                                        <template slot-scope="scope">
                                            <span>{{scope.row.gzprice | format}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>


                                <!-- END table-->
                            </dl>
                            <div v-if="item.apply.length < 99" style="width: 100%; text-align: right;">
                                <el-tooltip content="点击此按钮可添加数量" placement="top" effect="light">
                                    <el-button @click="addCartApply(item._id)"
                                               style="margin-top: 10px;" type="primary" icon="el-icon-plus"
                                               circle></el-button>
                                </el-tooltip>
                            </div>
                        </div>

                        <div class='item-3'>
                            <div class='price clearfix'>
                                总价
                                <span>{{item.gzprice *  item.apply.length | format}}</span>
                            </div>
                        </div>

                        <div class='item-4'>
                            <el-tooltip content="点击此按钮删除此订单" placement="top" effect="light">
                                <i class="close el-icon-close" @click="delcartbtn(item._id)"></i>
                            </el-tooltip>
                        </div>
                    </div>

                    <!-- 结算 -->
                    <div v-if="optFor > 0" class='cart-body-bot js-cart-body-bot'>
                        <div class='clearfix cart-body-bot-box'>
                            <div class='right'>
                                <ul class='clearfix'>
                                    <li class='li-2'>
                                        <div class='topdiv'>总计金额：</div>
                                        <div class='price price-red clearfix'>
                                            <!--<em>￥</em>-->
                                            <span class='jsAltogether'>{{totalPrice | format}}</span>
                                        </div>
                                    </li>

                                    <li class='li-3'>
                                        <span class='btn' @click="gopay">去结算</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- END结算 -->
                </div>
            </div>
            <div v-if="userNeme == '' || cartCount == 0">
                <p class="notdata">购物车内空空如也</p>
            </div>
        </div>
        <!--登入-->
        <login v-bind:loginShow="loginShow" v-bind:activeName="activeName" @close="closeloginModal"/>
        <!--编辑弹窗-->
        <el-dialog
                title="请输入身份证号码"
                :visible.sync="editDialogVisible"
                :show-close="false"
                :close-on-press-escape="false"
                width="430px"
                center
                :close-on-click-modal="false">
            <el-form :model="editForm" :rules="editrules" ref="editForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="身份证号" prop="cardId">
                    <el-input maxlength="18" placeholder="请输入身份证号码" v-model="editForm.cardId"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
    <el-button @click="closeeditDialogbtn">取 消</el-button>
    <el-button type="primary" @click="upeditbtn('editForm')">确 定</el-button>
  </span>
        </el-dialog>
    </div>

</template>

<script>
    import '../assets/css/cart.css'
    import axios from 'axios';
    import Login from "./login";
    import isIdCardNo from "../assets/common/isIdCardNo";

    export default {
        name: "Cart",
        computed: {
            userNeme() {
                return this.$store.state.userNeme;
            },
            cartCount() {
                return this.$store.state.cartCount;
            },
        },
        data() {
            var validatecardId = (rule, value, callback) => {
                if (!isIdCardNo(value.toUpperCase())) {
                    callback(new Error('您输入的身份证号码不正确'));
                } else {
                    callback();
                }
            };

            return {
                activeName: "login",
                loginShow: false,
                cartdata: [],
                //编辑弹窗
                editDialogVisible: false,
                //修改
                editForm: {},
                editrules: {
                    cardId: [
                        {required: true, message: '请输入身份证号码', trigger: 'blur'},
                        {validator: validatecardId, trigger: 'blur'}
                    ],
                },
                checked: true,
                //创建变量用来保存选中结果数
                selected: 0,
                //总价格
                totalPrice: 0,
                //选中的数量
                optFor: 0,
            }
        },
        components:
            {
                Login,
                axios,
                isIdCardNo
            }
        ,
        methods: {
            //关闭登入modal
            closeloginModal() {
                this.loginShow = false;
            },
            //获取购物车数据
            GetAllCartData() {
                axios.post("/Api/admin/getCartData").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            // 总价格和所选个数 清零
                            this.totalPrice = 0;
                            this.optFor = 0;

                            var linshi = res.data.data;
                            for (var num in linshi) {
                                var ls = linshi[num];
                                ls['chek'] = true;
                                this.totalPrice = this.totalPrice + (ls.gzprice * ls.apply.length);
                                this.optFor = this.optFor + ls.buyNumber;
                            }
                            this.cartdata = linshi;
                            this.selected = linshi.length;

                        } else if (res.data.errcode == 40000) {
                            this.loginShow = true;
                            //请先登入
                            this.$message({
                                showClose: true,
                                message: '请先登入',
                                type: 'error',
                                duration: 15000
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 10000
                            });
                        }

                    } else {
                        //操作失败
                        this.$message({
                            showClose: true,
                            message: '获取数据失败，请重新登入！',
                            type: 'error',
                            duration: 10000
                        });
                    }
                });
            },
            //编辑
            handleEdit(index, row) {
                this.editForm["data"] = row.data;
                this.editForm["num"] = index;
                if (row.data.apply[index] != "请点击右侧编辑按钮填写身份证号码") {
                    this.editForm.cardId = row.data.apply[index];
                }
                this.editDialogVisible = true;
            },
            //编辑的保存
            upeditbtn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //判断是否已包含某个身份证号码
                        if (this.editForm.data.apply.indexOf(this.editForm.cardId.toUpperCase()) == -1) {
                            this.editForm.data.apply[this.editForm.num] = this.editForm.cardId.toUpperCase();
                            this.saveCartApply(this.editForm.data);
                            this.closeeditDialogbtn();

                        } else {
                            //已有此身份证号码
                            this.$message({
                                showClose: true,
                                message: '此身份证号码已经添加,位置在第' + this.editForm.num + "行！",
                                type: 'error',
                                duration: 10000
                            });
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请输入正确的身份证号码',
                            type: 'error',
                            duration: 10000
                        });
                    }
                });
            },
            //关闭编辑 的按钮
            closeeditDialogbtn() {
                this.editForm = {};
                this.editDialogVisible = false;
            },
            //删除
            handleDelete(index, row) {
                var cardIddata = "";
                if (row.data.apply[index] == "请点击右侧编辑按钮填写身份证号码") {
                    cardIddata = "此";
                } else {
                    cardIddata = row.data.apply[index];
                }
                var msgdata = '';
                if (row.data.apply.length == 1) {
                    msgdata = '删除' + cardIddata + '数据后，此订单将被清除, 是否继续?';
                } else {
                    msgdata = '此操作将删除' + cardIddata + '数据, 是否继续?';
                }
                this.$confirm(msgdata, '删除报名数据', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    row.data.apply.splice(index, 1);
                    axios.post("/Api/admin/upCartApply", row.data).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除数据成功',
                                    type: 'success',
                                    duration: 10000
                                });
                                this.getStoreNumber();
                                this.GetAllCartData();
                            } else if (res.data.errcode == 1) {
                                this.$message({
                                    showClose: true,
                                    message: '删除数据成功。',
                                    type: 'success',
                                    duration: 10000
                                });
                                this.getStoreNumber();
                                //获取购物车数据
                                this.GetAllCartData();
                            } else {
                                //操作失败
                                this.$message({
                                    showClose: true,
                                    message: '删除失败，请重试！',
                                    type: 'error',
                                    duration: 20000
                                });
                            }

                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '删除失败，请重试！！！',
                                type: 'error',
                                duration: 20000
                            });
                        }
                    }).catch(err => {
                        this.$message({
                            showClose: true,
                            message: '删除失败，请重试！！',
                            type: 'error',
                            duration: 20000
                        });
                    });
                }).catch(() => {

                });


            },
            //设置表格数据
            setapplydata(data) {
                var setdata = [];
                for (var i = 0; i < data.apply.length; i++) {
                    setdata.push({"cardId": data.apply[i], "gzprice": data.gzprice, "id": data._id, data: data});
                }
                return setdata;
            },
            //保存购物车订单中的数组
            saveCartApply(data) {
                axios.post("/Api/admin/saveCartApply", data).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.$message({
                                showClose: true,
                                message: '编辑数据保存成功',
                                type: 'success',
                                duration: 5000
                            });

                        } else if (res.data.errcode == 40000) {
                            //请先登入
                            location.reload();
                        } else {
                            this.$message({
                                showClose: true,
                                message: '后台保存您的订单出错，请刷新或重试。',
                                type: 'error',
                                duration: 20000
                            });
                        }

                    } else {
                        //操作失败
                        this.$message({
                            showClose: true,
                            message: '后台保存您的订单出错，请重新登入！',
                            type: 'error',
                            duration: 20000
                        });
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '后台保存您的订单出错,请重新登入。。',
                        type: 'error',
                        duration: 20000
                    });
                });
            },
            //删除订单
            delcartbtn(data) {
                this.$confirm("此操作将删除整个订单数据，是否继续?", '删除订单数据', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post("/Api/admin/delCartApply", {"id": data}).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除订单成功',
                                    type: 'success',
                                    duration: 10000
                                });
                                this.getStoreNumber();
                                //获取购物车数据
                                this.GetAllCartData();
                            } else if (res.data.errcode == 40000) {
                                location.reload();
                            } else {
                                //操作失败
                                this.$message({
                                    showClose: true,
                                    message: '删除失败，请重试！',
                                    type: 'error',
                                    duration: 10000
                                });
                            }

                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '删除失败，请重试！！！',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    }).catch(err => {
                        this.$message({
                            showClose: true,
                            message: '删除失败，请重试！！',
                            type: 'error',
                            duration: 10000
                        });
                    });
                }).catch(() => {

                });
            },
            //获取订单数量
            getStoreNumber() {
                axios.post("/Api/admin/getStoreNumber").then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.$store.commit('upcartCount', res.data.data);
                        } else if (res.data.errcode == 40000) {
                            // this.$store.commit('upcartCount', res.data.data);
                        } else {
                            this.$store.commit('upcartCount', 0);
                        }
                    }
                });
            },
            //添加
            addCartApply(data) {
                axios.post("/Api/admin/addCartApply", {"id": data}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.$message({
                                showClose: true,
                                message: '添加成功！',
                                type: 'success',
                                duration: 5000
                            });
                            this.getStoreNumber();
                            this.GetAllCartData();
                        } else if (res.data.errcode == 40000) {
                            //请先登入
                            location.reload();
                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '添加失败！',
                                type: 'error',
                                duration: 10000
                            });
                        }
                    }
                });
            },
            //全选
            isAllchecked() {
                //全选
                if (this.checked) {
                    this.totalPrice = 0;
                    this.optFor = 0;
                    for (var num in this.cartdata) {
                        this.cartdata[num].chek = true;
                        this.totalPrice = this.totalPrice + (this.cartdata[num].gzprice * this.cartdata[num].apply.length);
                        this.optFor = this.optFor + this.cartdata[num].buyNumber;
                    }
                    this.selected = this.cartdata.length;
                } else {//全部取消
                    for (var num in this.cartdata) {
                        this.cartdata[num].chek = false;
                    }
                    this.totalPrice = 0;
                    this.selected = 0;
                    this.optFor = 0;
                }
            },
            //点选
            ischecked(data, obj) {
                //选中
                if (data) {
                    this.selected = this.selected + 1;
                    if (this.cartdata.length == this.selected) {
                        this.checked = true;
                    }
                    this.totalPrice = this.totalPrice + (obj.gzprice * obj.apply.length);
                    this.optFor = this.optFor + obj.buyNumber;
                } else {//取消
                    this.checked = false;
                    this.selected = this.selected - 1;
                    this.totalPrice = this.totalPrice - (obj.gzprice * obj.apply.length);
                    this.optFor = this.optFor - obj.buyNumber;
                }
            },
            //go pay
            gopay() {
                //计算选中的商品
                var yugoumai = [];
                for (var num in this.cartdata) {
                    if (this.cartdata[num].chek) {
                        if (this.cartdata[num].apply.indexOf("请点击右侧编辑按钮填写身份证号码") != -1) {
                            //有身份证号码没有填写
                            this.$message({
                                showClose: true,
                                message: '订单中有身份证没有填写！',
                                type: 'error',
                                duration: 10000
                            });
                            var altmsg = '位置在' + this.cartdata[num].gzleibie + '—' + this.cartdata[num].gzxiangmu + '—' + this.cartdata[num].gzleixing + '里的第' + (this.cartdata[num].apply.indexOf("请点击右侧编辑按钮填写身份证号码") + 1) + '条数据。';
                            this.$alert(altmsg, '没有填写身份证号码', {
                                confirmButtonText: '确定',
                                callback: action => {

                                }
                            });
                            return false;
                            break;
                        }
                        yugoumai.push(this.cartdata[num]._id);
                    }
                }
                this.$router.push({
                    name: 'Pay',
                    params: {
                        id: yugoumai
                    }
                })
            },
        },
        mounted() {
            //获取购物车数据
            this.GetAllCartData();
        },
        // watch: {
        //     cartCount() {
        //         // this.GetAllCartData();
        //     }
        // },
        filters: {  //数据过滤器
            format: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return "￥ " + value + ".00";
                }
                // else if (value.split('.')[1].substring(1) == 0) {
                //     value = Number(value).toFixed(2);
                // }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            }
        }
    }
</script>

